/**
 * Cross-references a packet's quality measures against an org-scoped measure
 * catalog (e.g. from `/dashboard/measures/{orgId}`) to fill in fields the
 * submission payload itself doesn't carry — notably `measureType`, which
 * `MipsValidationService.validateCehrtIdRequired` relies on to detect CMS
 * eCQM measures.
 */
export function enrichQualityData(quality: any, dashboardMeasures: any[]): any {
  if (!quality || !dashboardMeasures || dashboardMeasures.length === 0) {
    return quality;
  }

  const hasOutcomeHighPriority =
    quality.selectedMeasureIds?.some((measureId: string) => {
      const measure = dashboardMeasures.find((m) => m.name === measureId);
      return measure?.outcome === true || measure?.highpriority === true;
    }) ?? false;

  const enrichMeasures = (measures: any[]) =>
    measures?.map((m: any) => {
      const dashboardMeasure = dashboardMeasures.find(
        (dm) => dm.name === m.measureId,
      );
      if (dashboardMeasure) {
        return {
          ...m,
          isOutcome: dashboardMeasure.outcome === true,
          isHighPriority: dashboardMeasure.highpriority === true,
          measureTitle: dashboardMeasure.measureDescription || m.measureTitle,
          inverse: dashboardMeasure.inverse ?? m.inverse,
          measureType: dashboardMeasure.measureType ?? m.measureType,
        };
      }
      return m;
    }) ?? measures;

  const enrichedTraditionalMeasures = enrichMeasures(quality.traditionalMeasures);
  const enrichedMvpMeasures = enrichMeasures(quality.mvpMeasures);

  return {
    ...quality,
    hasOutcomeHighPriority,
    traditionalMeasures: enrichedTraditionalMeasures,
    mvpMeasures: enrichedMvpMeasures,
    allMeasures: [...enrichedTraditionalMeasures, ...enrichedMvpMeasures],
  };
}
